/**
 * Utility functions for platform detection
 */

/**
 * Detects if the app is running in standalone mode (added to home screen)
 * @returns {boolean} true if running in standalone mode
 */
export const isRunningStandalone = () => {
  // Check both display-mode media query and navigator.standalone (iOS)
  const displayStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const navigatorStandalone = window.navigator.standalone === true;
  
  // Additional check for iOS homescreen
  const isIOSHomeScreen = 
    (window.navigator.standalone === true) || 
    (window.matchMedia('(display-mode: standalone)').matches);
  
  console.log('Standalone detection:', { 
    displayStandalone, 
    navigatorStandalone,
    isIOSHomeScreen
  });
  
  return displayStandalone || navigatorStandalone || isIOSHomeScreen;
};
